import { useEffect, useState } from 'react';
import { useCart } from '@/context/CartContext';
import Link from 'next/link';
import {getCheckoutPageContent} from "@/lib/contentful";
export default function InitiationFee() {
  const { initiationFee } = useCart();

  const InitiationFeePrice =
    initiationFee?.variants?.edges[0]?.node?.price.amount;

  const [InitiationFeeContent, setInitiationFeeContent] =
    useState<Record<string, any>>(InitiationFeePrice);
  const FeeContent =
    InitiationFeeContent?.initiationFeeContent?.content[0]?.content[0]?.value;
    const ContentHeading =
      InitiationFeeContent?.initiationFeeHeading;
  const ContentButtonText =
    InitiationFeeContent?.initiationFeeContent?.content[0]?.content[1]
      ?.content[0].value;
  const ContentLink =
    InitiationFeeContent?.initiationFeeContent?.content[0]?.content[1]?.data
      .uri;

  useEffect(() => {
    // call contentent for supported text content
    if (initiationFee) {
      const contentFulInitiationFeeContent = async () => {
        const content = await getCheckoutPageContent();
        const feeText = content ?? null;
        //@todo: need to exam and drill down
        setInitiationFeeContent(feeText);
      };
      contentFulInitiationFeeContent();
    }
  }, [initiationFee]);

  return (
    <section
      className={
        'w-full h-auto flex flex-col justify-between  bg-gray-200'
      }
    >
      <div className="w-full h-auto justified-between flex flex-row p-2 text-[20px] pb-0">
        <div className={'w-full h-full flex flex-col xl:ml-10 pt-2'}>
          <p className={'font-medium mb-1'}>{ContentHeading}</p>
        </div>
        <div className={'w-full xl:h-full flex items-start justify-end pt-2'}>
          <p>${InitiationFeePrice}</p>
        </div>
      </div>
      <div className="w-full xl:w-[500px] h-auto mb-4 ml-2 pr-2 xl:pl-12">
        <div>
          {FeeContent}
          <span>
            <Link
              href={ContentLink ? ContentLink : ''}
              className="text-base font-[16px] text-[#FF6900]"
              data-tracking-id="learnmore-initiation-fee-cart"
              target="_blank"
            >
              {ContentButtonText}
            </Link>
          </span>
        </div>
      </div>
    </section>
  );
}
